import { createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';

let theme = createTheme({
    palette: {
        primary: {
            main: "#B71234",
            light: "#C5415C",
            dark: "#800C24"
        },
        secondary: {
            main: "rgb(171, 0, 60)",
            light: "rgb(211, 0, 85)",
            dark: "rgb(141, 0, 60)",
            contrastText: "rgba(0, 0, 0, 0.87)"
        },
        error: {
            main: "#F44336",
            light: "#E57373",
            dark: "#D32F2F"
        },
        danger: 'red',
        success: {
            main: '#4caf50',
            light: '#81c784',
            dark: '#388e3c'
        }
    },
    components: {
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    margin: 0,
                    padding: 0,
                }
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: "16px",
                }
            }
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    "& *": {
                        marginTop: "16px"
                    }
                }
            }
        }
    }
}, esES);

const SinapTheme = theme;

export default SinapTheme;
